import { render, staticRenderFns } from "./CustomFieldsListComponent.vue?vue&type=template&id=797f6d7a&scoped=true&lang=pug"
import script from "./CustomFieldsListComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsListComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsListComponent.vue?vue&type=style&index=0&id=797f6d7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f6d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797f6d7a')) {
      api.createRecord('797f6d7a', component.options)
    } else {
      api.reload('797f6d7a', component.options)
    }
    module.hot.accept("./CustomFieldsListComponent.vue?vue&type=template&id=797f6d7a&scoped=true&lang=pug", function () {
      api.rerender('797f6d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/customFieldsPlayground/CustomFieldsList/CustomFieldsListComponent.vue"
export default component.exports